/* eslint-disable react/prop-types */
import React from 'react';

type CheckMarkProps = { size?: number; color?: string } & React.SVGProps<SVGSVGElement>;

function CheckMark({ width, height, style }: CheckMarkProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 18 14" style={style}>
            <path
                fill="#062761"
                stroke="#062761"
                strokeWidth=".967"
                d="M6.43 13a.978.978 0 0 1-.706-.304l-4.43-4.594a1.067 1.067 0 0 1-.002-1.468.974.974 0 0 1 1.415-.001l3.724 3.861 8.862-9.19a.974.974 0 0 1 1.415 0c.39.407.39 1.064-.001 1.47l-9.57 9.922a.978.978 0 0 1-.706.304"
            />
        </svg>
    );
}
export default CheckMark;
